// Function to convert RGB to HSL
function rgbToHsl(r: number, g: number, b: number) {
  ((r /= 255), (g /= 255), (b /= 255));
  let max = Math.max(r, g, b),
    min = Math.min(r, g, b);
  let h,
    s,
    l = (max + min) / 2;

  if (max === min) {
    h = s = 0; // achromatic
  } else {
    let d = max - min;
    s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
    switch (max) {
      case r:
        h = (g - b) / d + (g < b ? 6 : 0);
        break;
      case g:
        h = (b - r) / d + 2;
        break;
      case b:
        h = (r - g) / d + 4;
        break;
    }
    h /= 6;
  }

  return [h, s, l];
}

// Function to convert HSL to RGB
function hslToRgb(h, s, l) {
  let r, g, b;

  if (s === 0) {
    r = g = b = l; // achromatic
  } else {
    const hue2rgb = (p, q, t) => {
      if (t < 0) t += 1;
      if (t > 1) t -= 1;
      if (t < 1 / 6) return p + (q - p) * 6 * t;
      if (t < 1 / 2) return q;
      if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6;
      return p;
    };

    let q = l < 0.5 ? l * (1 + s) : l + s - l * s;
    let p = 2 * l - q;
    r = hue2rgb(p, q, h + 1 / 3);
    g = hue2rgb(p, q, h);
    b = hue2rgb(p, q, h - 1 / 3);
  }

  return [Math.round(r * 255), Math.round(g * 255), Math.round(b * 255)];
}

// Function to convert RGB to hex color
function rgbToHex(r, g, b) {
  return "#" + ((1 << 24) + (r << 16) + (g << 8) + b).toString(16).slice(1);
}

const generateShade = ({
  color,
  baseColor = "#FFFFF",
  shade,
  darkMode = false,
}: {
  color: string;
  baseColor?: string;
  shade: number;
  darkMode?: boolean;
}) => {
  // Parse the hex color string to get
  let r = parseInt(color.slice(1, 3), 16);
  let g = parseInt(color.slice(3, 5), 16);
  let b = parseInt(color.slice(5, 7), 16);

  // Convert the base color to HSL
  let baseR = parseInt(baseColor.slice(1, 3), 16);
  let baseG = parseInt(baseColor.slice(3, 5), 16);
  let baseB = parseInt(baseColor.slice(5, 7), 16);
  let baseHsl = rgbToHsl(baseR, baseG, baseB);

  // Convert RGB to HSL
  let hsl = rgbToHsl(r, g, b);

  // 1100
  const multiplier = 1100;

  // Adjust lightness based on mode
  let adjustedLightness: number;
  if (darkMode) {
    // Dark mode: lightnessValue 0 means the darkest, 1000 means the lightest
    adjustedLightness = (shade / multiplier) * (1 - baseHsl[2]) + baseHsl[2];
  } else {
    // Light mode: lightnessValue 0 means the lightest, 1000 means the darkest
    adjustedLightness = baseHsl[2] - (shade / multiplier) * baseHsl[2];
  }

  // Generate the new color with adjusted lightness
  let rgb = hslToRgb(hsl[0], hsl[1], adjustedLightness);
  return rgbToHex(rgb[0], rgb[1], rgb[2]);
};

export default generateShade;
